import styled from '@emotion/styled'

/**
 * SearchInputDisplay — 결과 화면 공통 검색 인풋.
 *
 * Available/Unavailable 두 step 모두에서 사용. 스타일 소유권은 SearchInputDisplay에 두고
 * 두 step의 styles 파일은 본문 영역에만 책임.
 */

export const SearchInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 20px;
`

export const SearchInputBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 4px 4px 4px 12px;
  background: #ffffff;
  border: 1.5px solid #e4e5e7;
  border-radius: 8px;
`

export const SearchIconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`

export const SearchValueText = styled.p`
  flex: 1 0 0;
  min-width: 0;
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: #1b1c1d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ClearButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;

  &:active {
    opacity: 0.6;
  }
`
